<template>
  <transition
    name="expand"
    :mode="mode"
    @enter="enter"
    @after-enter="afterEnter"
    @leave="leave"
  >
    <slot/>
  </transition>
</template>

<script>
export default {
  name: 'TransitionExpand',
  props: {
    mode: {
      type: String,
      default: ''
    }
  },
  methods: {
    enter(element) {
      element.style.height = 'auto'

      const height = getComputedStyle(element).height

      element.style.height = 0

      requestAnimationFrame(() => {
        element.style.height = height
      })
    },
    afterEnter(element) {
      element.style.height = 'auto'
    },
    leave(element) {
      const height = getComputedStyle(element).height

      element.style.height = height

      requestAnimationFrame(() => {
        element.style.height = 0
      })
    }
  }
}
</script>

<style scoped lang="scss">
// https://markus.oberlehner.net/blog/transition-to-height-auto-with-vue/
.expand-enter-active,
.expand-leave-active {
  transition: opacity .5s, height .5s;
  overflow: hidden;
}
.expand-enter,
.expand-leave-to {
  opacity: 0;
  height: 0;
}

</style>
